module.exports = __webpack_public_path__ + "img/98.4ade519a.png";